// src/redux/auth.js
import {
  login,
  logout,
  passwordRecoveryRequest,
  passwordRecoveryReset,
  // passwordRecoveryVerify, // если понадобится отдельная проверка кода
} from '../services/api';
import { setAuthority } from '../utils/authority';
import {notification} from "antd";
import {getBackendErrorMessage} from "../utils/errorMessages";

// login user (как было)
export const LOGIN = 'sckrg/auth/LOGIN';
export const loginUser = (values) => async (dispatch) => {
  try {

    const user = await login(values);

    setAuthority('AUTHED');
    dispatch({ type: LOGIN, payload: user });
    window.localStorage.setItem('user_params', JSON.stringify(user));
    window.location.assign('/');
  } catch (e) {
    const description = getBackendErrorMessage(
        e,
        'Не удалось выполнить вход. Попробуйте позже.'
    );

    notification.error({
      message: 'Ошибка авторизации',
      description,
    });

  }
};

// logout user (как было)
export const LOGOUT = 'sckrg/auth/LOGOUT';
export const logoutUser = async (dispatch) => {
  try {
    await logout();
    setAuthority('GUEST');
    window.localStorage.removeItem('user_params');
    dispatch({ type: LOGOUT });

  } catch (error) {
    console.error('Logout failed:', error);
  }

};

// === Новое: восстановление пароля

export const requestPasswordReset = async(email) =>  {
  try {
    await passwordRecoveryRequest(email);
    return true;
  } catch (e) {
    console.error('requestPasswordReset failed:', e);
    notification.error({
      message: 'Ошибка',
      description: e?.message || 'Не удалось отправить письмо. Попробуйте позже.'
    });
    return false;
  }
};

export const RESET_PASSWORD = 'sckrg/auth/RESET_PASSWORD';
export const performPasswordReset = (token, password) => async (dispatch) => {
  try {
    await passwordRecoveryReset({ token, newPassword: password });
    dispatch({ type: RESET_PASSWORD, payload: { ok: true } });
    return true;
  } catch (e) {
    console.error('performPasswordReset failed:', e);
    notification.error({
    message: 'Ошибка',
    description: e?.message || 'Не удалось сбросить пароль. Попробуйте позже.'
  });
    return false;
  }
};

